import React, { useContext } from 'react'
import { Context } from '../../../contexts/Context'
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'

export default function SortBy () {
  const { handleSortRangeSelect, filters } = useContext(Context)

  const handleChange = (e) => {
    handleSortRangeSelect(e.target.value)
  }

  return (
    <FormControl
      sx={{ background: 'white', maxWidth: 150 }} size='small' fullWidth
    >
      <InputLabel sx={{ lineHeight: 1, fontSize: 16 }} id='demo-simple-select-label filter_by'>Sort by</InputLabel>
      <Select
        sx={{ background: 'white', height: 30, borderRadius: '10px' }}
        labelId='demo-simple-select-label'
        id='demo-simple-select sort_by'
        value={filters.sort}
        label='Distance'
        onChange={handleChange}
      >
        <MenuItem value='distance'>Distance</MenuItem>
        <MenuItem value='time'>Time</MenuItem>
      </Select>
    </FormControl>
  )
}
